var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sale)?_c('b-row',{staticClass:"m-t-15"},[_c('b-col',{attrs:{"md":"6"}},[_c('discounts')],1),_c('b-col',{attrs:{"md":"6"}},[_c('surchages')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }